/* tslint:disable */
/* eslint-disable */
/**
 * Xpanse Portal BFF Service API
 * Rest API for Xpanse Portal
 *
 * The version of the OpenAPI document: @project.version@
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportingDashboardDTO
 */
export interface ReportingDashboardDTO {
    /**
     * 
     * @type {string}
     * @memberof ReportingDashboardDTO
     */
    alias: string;
    /**
     * 
     * @type {string}
     * @memberof ReportingDashboardDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReportingDashboardDTO
     */
    slug: string;
}

/**
 * Check if a given object implements the ReportingDashboardDTO interface.
 */
export function instanceOfReportingDashboardDTO(value: object): value is ReportingDashboardDTO {
    if (!('alias' in value) || value['alias'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    return true;
}

export function ReportingDashboardDTOFromJSON(json: any): ReportingDashboardDTO {
    return ReportingDashboardDTOFromJSONTyped(json, false);
}

export function ReportingDashboardDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingDashboardDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'alias': json['alias'],
        'name': json['name'],
        'slug': json['slug'],
    };
}

export function ReportingDashboardDTOToJSON(json: any): ReportingDashboardDTO {
    return ReportingDashboardDTOToJSONTyped(json, false);
}

export function ReportingDashboardDTOToJSONTyped(value?: ReportingDashboardDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alias': value['alias'],
        'name': value['name'],
        'slug': value['slug'],
    };
}

